import React from 'react';

const before = [
  ['00:00', 'Procura o modelo certo', '“final”, “final 2” ou o que estava no WhatsApp?'],
  ['00:09', 'Copia identificação e cabeçalho', 'confere nome, data, registro e local outra vez'],
  ['00:23', 'Escreve e formata o laudo', 'a quebra de página decide participar da consulta'],
  ['01:11', 'Salva, renomeia e exporta', 'mais uma versão para a pasta'],
  ['01:25', 'Tenta achar o documento depois', 'o arquivo existe; a pergunta é onde'],
];

const after = [
  ['01', 'Escolhe um modelo salvo', 'estrutura pronta para preencher'],
  ['02', 'Preenche o laudo', 'paciente, local, assinatura e conteúdo no mesmo fluxo'],
  ['03', 'Emite o documento', 'registro, hash e código de validação são associados ao laudo'],
  ['04', 'Compartilha ou imprime', 'o documento continua no histórico para consulta'],
  ['05', 'Reutiliza o que já funciona', 'modelos, locais e assinaturas ficam disponíveis no próximo laudo'],
];

const Timeline = ({ title, items, quiet = false }) => (
  <article className={`rounded-card border p-6 md:p-8 ${quiet ? 'bg-paper border-line' : 'bg-navy text-white border-navy'}`}>
    <h3 className={`font-display text-2xl font-bold mb-8 ${quiet ? 'text-navy' : 'text-white'}`}>{title}</h3>
    <div className="space-y-0">
      {items.map(([time, label, note], index) => (
        <div key={label} className={`grid grid-cols-[54px_1fr] gap-4 py-4 ${index ? `border-t ${quiet ? 'border-line' : 'border-white/10'}` : ''}`}>
          <span className={`font-mono text-xs pt-0.5 ${quiet ? 'text-selo' : 'text-white/60'}`}>{time}</span>
          <div>
            <p className={`text-sm font-semibold ${quiet ? 'text-ink' : 'text-white'}`}>{label}</p>
            <p className={`text-sm mt-1 ${quiet ? 'text-muted' : 'text-white/60'}`}>{note}</p>
          </div>
        </div>
      ))}
    </div>
  </article>
);

const BeforeAfter = () => (
  <section className="bg-paper-alt py-24 md:py-32 px-4" aria-labelledby="antes-depois-title">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-3xl mb-12">
        <h2 id="antes-depois-title" className="font-display text-3xl md:text-5xl font-bold tracking-[-0.025em] text-navy">
          O laudo não precisa começar procurando <em className="font-semibold text-selo">o arquivo certo.</em>
        </h2>
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <Timeline title="Antes: Word, pastas e versões soltas" items={before} />
        <Timeline title="Com o Laudando: um fluxo só" items={after} quiet />
      </div>
      <p className="text-xs text-muted mt-5 max-w-3xl">Os passos acima descrevem o fluxo; não são uma promessa de tempo por laudo. O tempo real varia conforme o exame e o conteúdo clínico.</p>
    </div>
  </section>
);

export default BeforeAfter;
